<template>
  <b-modal
    v-model="showModal"
    size="xl"
    hide-footer
    centerd
    header-class="TransferMatchModalHeaderVariant"
    modal-class="modal-fluid"
    content-class="TransferMatchModalContentVariant"
    header-text-variant="white"
    @shown="getConstructionCodeAPI()"
    @hidden="hideModal()"
    :no-close-on-backdrop="true"
    :title="title"
  >
    <template v-slot:default>
      <div>
        <div class="d-flex justify-content-between" style="max-width: 890px;">
          <div>
            <div>
              <label style="margin: 0;">{{ office + " " + part + " " + section}}</label>
            </div>
            <div>
              <label style="padding-right: 0.5em; margin: 0;">{{ targetShainCd }}</label>
              <label style="font-size: 1.5rem; margin: 0;">{{ name }}</label>
            </div>
          </div>
          <div class="d-flex align-items-end">
            <div>
              <label style="margin: 0;" v-if="!emptyCheck(targetDate)">{{ targetDate }}時点</label>
              <label class="spacer"></label>
              <label style="margin: 0;" v-if="validityPeriod > 0">{{ validityPeriod }}日以内</label>
              <label style="margin: 0;" v-else>1年以内</label></div>
            </div>
          <!--検索欄-->
          <div class="d-flex align-items-end">
            <b-form-radio-group v-model="viewStatus" button-variant="outline-primary" size="sm" buttons @change="getConstructionCodeAPI()">
              <b-form-radio value="0">すべて</b-form-radio>
              <label class="spacer"></label>
              <b-form-radio value="1">未照合</b-form-radio>
            </b-form-radio-group>
          </div>
        </div>
        <!--一覧-->
        <div class="mt-3 dispTable">
          <!--休出一覧-->
          <div class="mr-3 w-100 mt-2">
            <!-- <div class="WorkM_InputGroup_ItemLabel_Transfer transfer_icon_color_work2">休日出勤</div> -->
            <div class="SubstituteWorkListArea small">
              <b-form-radio-group v-model="selectWork">
                <b-table 
                class="TransferSubstituteWorkListTable mb-0" 
                :items="substituteWorkListData" 
                :fields="substituteWorkListFields" 
                small 
                sticky-header
                no-border-collapse	
                selectable
                select-mode='single'
                selected-variant="a bg-primary"
                :tbody-tr-class="rowWorkClass"
                @row-clicked="setSelectSubstituteWork"
                bordered
                ref="TransferSubstituteWorkList">
                  <template #thead-top="">
                    <b-tr style="border: none;">
                      <b-th colspan="7" style="border: none;">
                        <div style="margin-bottom: -8px;" class="WorkM_InputGroup_ItemLabel_Transfer transfer_icon_color_work2">休日出勤</div>
                      </b-th>
                      <b-th colspan="4" style="text-align: center; font-weight: bold; background-color: #002d64; color: white">休日出勤に対応する振替休日</b-th>
                    </b-tr>
                  </template>
                  <template v-slot:head(substituteHolidayDate)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(substituteHolidayStartTime)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(substituteHolidayEndTime)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(substituteHolidayTime)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(constructionCode)="title">
                    <div style="height:100%; text-align:center; font-size: 15px;">{{ title.field.label }}</div>
                  </template>
                  <template v-slot:cell(selected)="data" v-if="true">
                    <div class="" style="height:27px;">
                      <b-form-radio 
                      v-if="!data.item.substitutedFlag" 
                      @change="setSelectSubstituteWork(data.item)"
                      style="padding-left:35px;"
                      class="mr-0 d-flex justify-content-center"
                      :value=data.item.detailNo
                      ></b-form-radio>
                    </div>
                  </template>
                  <template v-slot:cell(workingDate)="data">
                    <div v-if="data.item.workingDate != null && data.item.workingDate != ''">
                      {{ data.item.workingDateJp + "(" + getDayOfWeek(data.item.workingDateJp) + ")" }}
                    </div>
                  </template>
                  <template v-slot:cell(substituteHolidayDate)="data">
                    <div v-if="data.item.substituteHolidayDateJp != null && data.item.substituteHolidayDateJp != ''">
                      {{ data.item.substituteHolidayDateJp + "(" + getDayOfWeek(data.item.substituteHolidayDateJp) + ")" }}
                    </div>
                  </template>
                  <template v-slot:cell(constructionName)="data">
                    <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ data.item.constructionName }}</div>
                  </template>
                </b-table>
              </b-form-radio-group>
            </div>
          </div>
          <!--振休一覧-->
          <div class="w-100 mt-2">
            <!-- <div class="WorkM_InputGroup_ItemLabel_Transfer transfer_icon_color_holiday2">振替休日</div> -->
            <div class="SubstituteWorkListArea small">
              <b-form-radio-group v-model="selectHoliday">
                <b-table 
                class="TransferSubstituteHolidayListTable mb-0" 
                :items="substituteHolidayListData" 
                :fields="substituteHolidayListFields" 
                small 
                sticky-header
                no-border-collapse	
                selectable
                select-mode='single'
                selected-variant="a bg-primary"
                :tbody-tr-class="rowHolidayClass"
                @row-clicked="setSelectSubstituteHoliday" 
                bordered
                ref="SubstituteWorkList">
                  <template #thead-top="">
                    <b-tr style="border: none;">
                      <b-th colspan="5" style="border: none;">
                        <div style="margin-bottom: -8px;" class="WorkM_InputGroup_ItemLabel_Transfer transfer_icon_color_holiday2">振替休日</div>
                      </b-th>
                      <b-th colspan="6" style="text-align: center; font-weight: bold; background-color: #004949; color: white">振替休日に対応する休日出勤</b-th>
                    </b-tr>
                  </template>
                  <template v-slot:head()="title">
                    {{ title.field.label }}
                  </template>
                  <template v-slot:head(workingDate)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(workingStartTime)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(workingEndTime)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(workingTime)="title">
                    {{ title.field.label2 }}
                  </template>
                  <template v-slot:head(constructionCode)="title">
                    <div style="height:100%; text-align:center; font-size: 15px;">{{ title.field.label }}</div>
                  </template>
                  <template v-slot:cell(selected)="data">
                    <div class="" style="height:27px;">
                      <b-form-radio 
                      v-if="!data.item.substitutedFlag" 
                      class="mr-0 d-flex justify-content-center"
                      @change="setSelectSubstituteHoliday(data.item)"
                      :value=data.item.detailNo
                      style="padding-left:35px;"
                      ></b-form-radio>
                    </div>
                  </template>
                  <template v-slot:cell(workingDate)="data">
                    <div  v-if="data.item.workingDateJp != null && data.item.workingDateJp != ''">
                      {{ data.item.workingDateJp + "(" + getDayOfWeek(data.item.workingDateJp) + ")" }}
                    </div>
                  </template>
                  <template v-slot:cell(substituteHolidayDate)="data">
                    <div  v-if="data.item.substituteHolidayDateJp != null && data.item.substituteHolidayDateJp != ''">
                      {{ data.item.substituteHolidayDateJp + "(" + getDayOfWeek(data.item.substituteHolidayDateJp) + ")" }}
                    </div>
                  </template>
                  <template v-slot:cell(constructionName)="data">
                    <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ data.item.constructionName }}</div>
                  </template>
                </b-table>
              </b-form-radio-group>
            </div>
          </div>
        </div>
        <!--照合内容確認-->
        <!-- <div class="mt-2 d-flex align-items-center justify-content-center" style="min-width:1300px; position:relative"> -->
        <div class="mt-2 d-flex align-items-center justify-content-between" style="position:relative">
          <div class="text-left w-20"></div>

          <!-- <div class="text-center mx-auto w-60"> -->
          <div class="text-center w-60">
            <div class="d-flex justify-content-between">
              <b-icon class="transfer_icon_color_work2" icon="arrow-down" font-scale="2"></b-icon>
              <b-icon class="transfer_icon_color_holiday2 ml-3" icon="arrow-down" font-scale="2"></b-icon>
            </div>
            <div class="border-bottom border-dark text-center mt-1 d-flex" style="min-width:390px">
              <label class="mb-0">休日出勤：</label>
              <div style="min-width:300px">
                <label class="mb-0"
                v-if="!emptyCheck(select_substitute_work_day) && !emptyCheck(select_substitute_work_start) && !emptyCheck(select_substitute_work_end) && !emptyCheck(select_substitute_work_time)">
                  {{ select_substitute_work_day + " " + select_substitute_work_start + " ～ " + select_substitute_work_end + " " + select_substitute_work_time }}
                </label>
              </div>
            </div>
            <div class="border-bottom border-dark text-center mt-1 d-flex" style="min-width:390px">
              <label class="mb-0">振替休日：</label>
              <div style="min-width:300px">
                <label class="mb-0"
                v-if="!emptyCheck(select_substitute_holiday_day) && !emptyCheck(select_substitute_holiday_start) && !emptyCheck(select_substitute_holiday_end) && !emptyCheck(select_substitute_holiday_time)">
                  {{ select_substitute_holiday_day + " " + select_substitute_holiday_start + " ～ " + select_substitute_holiday_end + " " + select_substitute_holiday_time }}
                </label>
              </div>
            </div>
          </div>
          
          <!-- <div class="text-left" style="position:absolute; right:0;bottom:0"> -->
          <div class="text-left w-20">
            <div class="text-left mt-1" style="font-size:0.9rem;">
              <label class="mb-0">紐づける休日出勤と振替休日をリストから選択し、照合ボタンを押してください。</label>
            </div>
          </div>
        </div>
        <!--ボタン-->
        <div class="mt-4">
          <div class="d-flex justify-content-between flex-row-reverse">
            <div class="WorkM_Button WorkM_ButtonSuccess" @click="btnMatch">照合</div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import config from "../../const/config";
export default {
  name:"TransferMatchModal",
  // TODO: 親画面より引き渡す引数を追加
  props:{
    loginUserId: {type:String, default:null},
    office:{type:String, default:null},
    part:{type:String, default:null},
    section:{type:String, default:null},
    shainCd:{type:String, default:null},
    name:{type:String, default:null},
    targetDate:{type:String, default:null},
    validityPeriod:{type:Number, default:0},
  },
  data: function(){
    return{
      // targetDate: "2024/12/01",
      // validityPeriod: 360,
      targetShainCd: 0,
      viewStatus: 0,
      showModal: false,
      title: "振替照合",
      substituteWorkListFields: [
        {
          key: 'selected',
          class: 'col_transfer_radio',
          thClass: 'table-header',
          label: "選択",
        },
        {
          key: 'workingDate',
          class: 'col_transfer_day',
          thClass: 'table-header',
          label: "日付",
        },
        {
          key: 'workingStartTime',
          class: 'col_transfer_start',
          thClass: 'table-header',
          label: "開始",
        },
        {
          key: 'workingEndTime',
          class: 'col_transfer_end',
          thClass: 'table-header',
          label: "終了",
        },
        {
          key: 'workingTime',
          class: 'col_transfer_time',
          thClass: 'table-header',
          label: "時間",
        },
        {
          key: 'constructionCode',
          class: 'col_transfer_construction_code',
          thClass: 'table-header',
          label: "工事CD",
        },
        {
          key: 'constructionName',
          class: 'col_transfer_construction_name',
          thClass: 'table-header',
          label: "工事名",
        },
        {
          key: 'substituteHolidayDate',
          class: 'col_transfer_day bg_transfer_holiday',
          thClass: 'table-header',
          label1: "振休",
          label2: "日付",
        },
        {
          key: 'substituteHolidayStartTime',
          class: 'col_transfer_start bg_transfer_holiday',
          thClass: 'table-header',
          label1: "振休",
          label2: "開始",
        },
        {
          key: 'substituteHolidayEndTime',
          class: 'col_transfer_end bg_transfer_holiday',
          thClass: 'table-header',
          label1: "振休",
          label2: "終了",
        },
        {
          key: 'substituteHolidayTime',
          class: 'col_transfer_time bg_transfer_holiday',
          thClass: 'table-header',
          label1: "振休",
          label2: "時間",
        },
      ],
      substituteWorkListDataFromAPI:[],
      substituteWorkListData: [],
      substituteHolidayListFields: [
        {
          key: 'selected',
          class: 'col_transfer_radio',
          thClass: 'table-header',
          label: "選択",
        },
        {
          key: 'substituteHolidayDate',
          class: 'col_transfer_day',
          thClass: 'table-header',
          label: "日付",
        },
        {
          key: 'substituteHolidayStartTime',
          class: 'col_transfer_start',
          thClass: 'table-header',
          label: "開始",
        },
        {
          key: 'substituteHolidayEndTime',
          class: 'col_transfer_end',
          thClass: 'table-header',
          label: "終了",
        },
        {
          key: 'substituteHolidayTime',
          class: 'col_transfer_time',
          thClass: 'table-header',
          label: "時間",
        },
        {
          key: 'workingDate',
          class: 'col_transfer_day bg_transfer_work',
          thClass: 'table-header',
          label1: "休出",
          label2: "日付",
        },
        {
          key: 'workingStartTime',
          class: 'col_transfer_start bg_transfer_work',
          thClass: 'table-header',
          label1: "休出",
          label2: "開始",
        },
        {
          key: 'workingEndTime',
          class: 'col_transfer_end bg_transfer_work',
          thClass: 'table-header',
          label1: "休出",
          label2: "終了",
        },
        {
          key: 'workingTime',
          class: 'col_transfer_time bg_transfer_work',
          thClass: 'table-header',
          label1: "休出",
          label2: "時間",
        },
        {
          key: 'constructionCode',
          class: 'col_transfer_construction_code bg_transfer_work',
          thClass: 'table-header',
          label: "工事CD",
        },
        {
          key: 'constructionName',
          class: 'col_transfer_construction_name bg_transfer_work',
          thClass: 'table-header',
          label: "工事名",
        },
      ],
      substituteHolidayListDataFromAPI:[],
      substituteHolidayListData: [],
      select_substitute_work_day: null,
      select_substitute_work_start: null,
      select_substitute_work_end: null,
      select_substitute_work_time: null,
      select_substitute_holiday_day: null,
      select_substitute_holiday_start: null,
      select_substitute_holiday_end: null,
      select_substitute_holiday_time: null,
      selectWork: null,
      selectWorkDate: 0,
      selectHoliday: null,
      selectHolidayDate: 0,
    };
  },
  computed:{
    shainCdInit(){
      return this.shainCd;
    },
    
  },
  mounted: function(){},
  methods: {
    // ========= イベント処理
    openModal: function(){
      this.selectWork = 0;
      this.selectHoliday = 0;
      this.selectWorkDate = null;
      this.selectHolidayDate = null;
      this.select_substitute_work_day = null;
      this.select_substitute_work_start = null;
      this.select_substitute_work_end = null;
      this.select_substitute_work_time = null;
      this.select_substitute_holiday_day = null;
      this.select_substitute_holiday_start = null;
      this.select_substitute_holiday_end = null;
      this.select_substitute_holiday_time = null;
      this.showModal = true;
      this.viewStatus = 0;
    },
    hideModal: function() {
      // 親イベントFire
      this.$emit("emitModal");
    },
    // 照会ボタン押下時イベント
    btnMatch: function(){
      if (this.emptyCheck(this.selectWork) || this.emptyCheck(this.selectWorkDate)){
        this.showAlertError("休日出勤をリストから選択してください。");
        return;
      }
      if (this.emptyCheck(this.selectHoliday) || this.emptyCheck(this.selectHolidayDate)){
        this.showAlertError("振替休日をリストから選択してください。");
        return;
      }
      // パラメータセット
      let paramList = {
        managerShainCd: this.loginUserId,
        shainCd: this.targetShainCd,
        workingReportNo: this.selectWork,
        workingDate: this.selectWorkDate,
        substituteReportNo: this.selectHoliday,
        substituteHolidayDate: this.selectHolidayDate,
      }
      console.debug("paramList：" + JSON.stringify(paramList));
      // 確認メッセージ
      let showMessageWork = this.select_substitute_work_day + " " + this.select_substitute_work_start + " ～ " + this.select_substitute_work_end + " " + this.select_substitute_work_time;
      let showMessageHoliday = this.select_substitute_holiday_day + " " + this.select_substitute_holiday_start + " ～ " + this.select_substitute_holiday_end + " " + this.select_substitute_holiday_time;
      this.$confirm("以下の内容で照合します。"
      + "<br>休日出勤：" + showMessageWork
      + "<br>振替休日：" + showMessageHoliday
      + "<br>よろしいですか？"
      , "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          dangerouslyUseHTMLString: true,
          customClass:"editCheckModalWidthHeader"
      })
        .then(() => {
          this.postData(config.URL.SUBSTITUTE_HOLODAY_MANAGE_CHECK_MATCH_INFO, paramList)
            .then((response) => {
              // --- レスポンスの結果チェック
              if (!response.result) {
                // エラーメッセージを表示
                if (!this.emptyCheck(response.message)) {
                  this.showAlertError(response.message);
                } else {
                  this.showAlertError(config.MESSAGE.SERVER_ERROR);
                }
                return;
              }

              // --- チェック結果を基に次処理を決定
              let resInfo = response.container;
              if (!resInfo.hasError) {
                // エラーなし -> 照合処理実行
                this.executeSubstituteMatch();
                return;
              }
              if (resInfo.userSelection && !this.emptyCheck(resInfo.message)) {
                // エラーあり かつ 次処理ユーザ選択 かつ メッセージあり
                this.$confirm(resInfo.message, "確認",
                  {
                    confirmButtonText: "OK"
                    , cancelButtonText: "キャンセル"
                    , dangerouslyUseHTMLString: true
                    , customClass: "editCheckModalWidthHeader"
                  }
                ).then(() => {
                  // ユーザ選択により、照合処理実行
                  this.executeSubstituteMatch();
                });
                return;
              } else {
                // エラーあり かつ 次処理NGのみ
                if (!this.emptyCheck(response.message)) {
                  this.showAlertError(response.message);
                } else {
                  this.showAlertError(config.MESSAGE.SERVER_ERROR);
                }
                return;
              }
            })
            .catch((e) => {
                // Note: エラーメッセージは、共通処理で表示している
                console.error(e);
            })
            .finally(() => {});
        })
    },
    // 照合処理API実行
    executeSubstituteMatch: function() {
      console.info("Execute SubstituteMatch.");

      // パラメータセット
      let paramList = {
        managerShainCd: this.loginUserId,
        shainCd: this.targetShainCd,
        workingReportNo: this.selectWork,
        workingDate: this.selectWorkDate,
        substituteReportNo: this.selectHoliday,
        substituteHolidayDate: this.selectHolidayDate,
        skipMatchTime: true,
      }
      // API実行
      this.postData(config.URL.SUBSTITUTE_HOLIDAY_MANAGE, paramList)
        .then((response) => {
            // レスポンスの結果がfalseならエラーメッセージを表示
            if(!response.result){
              if(!this.emptyCheck(response.message)){
                this.showAlertError(response.message);
                return;
              }
              this.showAlertError(config.MESSAGE.SERVER_ERROR);
              return;
            }
            // 一覧表に結果をセット
            this.getConstructionCodeAPI();
            this.selectWork = 0;
            this.selectHoliday = 0;
            this.selectWorkDate = null;
            this.selectHolidayDate = null;
        })
        .catch((e) => {
            // Note: エラーメッセージは、共通処理で表示している
            console.error(e);
        })
        .finally(() => {});
    },
    //============= API呼出
    getConstructionCodeAPI: function(){
      console.info("this.shainCdInit:" + this.shainCdInit);

      this.targetShainCd = this.shainCdInit;
      console.info("this.targetShainCd:" + this.targetShainCd);
      console.info("this.viewStatus:" + this.viewStatus);
      let paramList = {
        shainCd: this.targetShainCd,
        targetType: this.viewStatus
      }
      this.getWithParams(config.URL.SUBSTITUTE_HOLIDAY_MANAGE_PERSONAL_INFO, paramList)
        .then((response) => {
            console.debug("response：" + JSON.stringify(response));
            // レスポンスの結果がfalseならエラーメッセージを表示
            if(!response.result){
              if(!this.emptyCheck(response.message)){
                this.showAlertError(response.message);
                return;
              }
              this.showAlertError(config.MESSAGE.SERVER_ERROR);
              return;
            }
            // 一覧表に結果をセット
            this.setIndex(response.container);
        })
        .catch((e) => {
            // Note: エラーメッセージは、共通処理で表示している
            console.error(e);
        })
        .finally(() => {});
    },

    //============= 表操作
    // 読み込んだJSONを一覧にセット
    setIndex: function(items){
        this.substituteWorkListDataFromAPI = items.workingOnHolidaysList;
        this.substituteWorkListData = [];
        let substituteWorkListDataArr = [];
        this.substituteWorkListDataFromAPI.forEach(function(WorkListDataFromAPI){
          let isShowConstuctionInfo = WorkListDataFromAPI.constructionCode == 0 || WorkListDataFromAPI.constructionCode == null;
          let record =   {
              selected: true, 
              substitutedFlag: WorkListDataFromAPI.substitutedFlag, 
              detailNo: WorkListDataFromAPI.reportNoForWorking,
              workingDate: WorkListDataFromAPI.workingDate,
              workingDateJp: WorkListDataFromAPI.workingDateJp,
              workingStartTime: WorkListDataFromAPI.workingStartTime,
              workingEndTime: WorkListDataFromAPI.workingEndTime,
              workingTime: WorkListDataFromAPI.workingTime,
              constructionCode: isShowConstuctionInfo ? "" : WorkListDataFromAPI.constructionCode,
              constructionName: isShowConstuctionInfo ? "" : WorkListDataFromAPI.constructionName,
              substituteHolidayDate: WorkListDataFromAPI.substituteHolidayDate,
              substituteHolidayDateJp: WorkListDataFromAPI.substituteHolidayDateJp,
              substituteHolidayStartTime: WorkListDataFromAPI.substituteHolidayStartTime,
              substituteHolidayEndTime: WorkListDataFromAPI.substituteHolidayEndTime,
              substituteHolidayTime:  WorkListDataFromAPI.substituteHolidayTime,
          };
          console.log("WorkListDataFromAPI.workingDate:"+ WorkListDataFromAPI.workingDate);
          console.log("WorkListDataFromAPI.constructionName:"+ WorkListDataFromAPI.constructionName);
          substituteWorkListDataArr.push(record);
        })
        this.substituteWorkListData = substituteWorkListDataArr;
        
        // 振替休日一覧
        this.substituteHolidayListDataFromAPI = items.substituteHolidayList;
        this.substituteHolidayListData = [];
        let substituteHolidayListDataArr = [];
        this.substituteHolidayListDataFromAPI.forEach(function(WorkListDataFromAPI){
          let isShowConstuctionInfo = WorkListDataFromAPI.constructionCode == 0 || WorkListDataFromAPI.constructionCode == null;
          let record =   {
              selected: true, 
              substitutedFlag: WorkListDataFromAPI.substitutedFlag, 
              detailNo: WorkListDataFromAPI.reportNoForSubstitute,
              substituteHolidayDate: WorkListDataFromAPI.substituteHolidayDate,
              substituteHolidayDateJp: WorkListDataFromAPI.substituteHolidayDateJp,
              substituteHolidayStartTime: WorkListDataFromAPI.substituteHolidayStartTime,
              substituteHolidayEndTime: WorkListDataFromAPI.substituteHolidayEndTime,
              substituteHolidayTime:  WorkListDataFromAPI.substituteHolidayTime,
              workingDate: WorkListDataFromAPI.workingDate,
              workingDateJp: WorkListDataFromAPI.workingDateJp,
              workingStartTime: WorkListDataFromAPI.workingStartTime,
              workingEndTime: WorkListDataFromAPI.workingEndTime,
              workingTime: WorkListDataFromAPI.workingTime,
              constructionCode: isShowConstuctionInfo ? "" : WorkListDataFromAPI.constructionCode,
              constructionName: isShowConstuctionInfo ? "" : WorkListDataFromAPI.constructionName,
          };
          console.log("WorkListDataFromAPI.workingDate:"+ WorkListDataFromAPI.workingDate);
          console.log("WorkListDataFromAPI.constructionName:"+ WorkListDataFromAPI.constructionName);
          substituteHolidayListDataArr.push(record);
        })
        this.substituteHolidayListData = substituteHolidayListDataArr;


        console.log("substituteWorkListDataFromAPI:" + JSON.stringify(this.substituteWorkListDataFromAPI));
        console.log("substituteHolidayListDataFromAPI:" + JSON.stringify(this.substituteHolidayListDataFromAPI));
    },

    // 選択された行の内容を休日出勤に表示する
    setSelectSubstituteWork: function(data){
      if(!data.substitutedFlag){
        this.selectWork = data.detailNo;
        this.selectWorkDate = data.workingDate;
        this.select_substitute_work_day = data.workingDateJp;
        this.select_substitute_work_start = data.workingStartTime;
        this.select_substitute_work_end = data.workingEndTime;
        this.select_substitute_work_time = data.workingTime;
      }
    },
    // 選択された行の内容を振替休日に表示する
    setSelectSubstituteHoliday: function(data){
      console.log(JSON.stringify(data));
      if(!data.substitutedFlag){
        this.selectHoliday = data.detailNo;
        this.selectHolidayDate = data.substituteHolidayDate;
        this.select_substitute_holiday_day = data.substituteHolidayDateJp;
        this.select_substitute_holiday_start = data.substituteHolidayStartTime;
        this.select_substitute_holiday_end = data.substituteHolidayEndTime;
        this.select_substitute_holiday_time = data.substituteHolidayTime;
      }
    },
    rowWorkClass(item, type) {
      console.log("call rowWorkClass");
      if (!item || type !== 'row') return
      if (item.detailNo == this.selectWork && !this.checkLink(item.holiday_day)) return 'bg-primary text-white'
      else return 'bg-white text-dark'
    },
    rowHolidayClass(item, type) {
      console.log("call rowWorkClass");
      if (!item || type !== 'row') return
      if (item.detailNo == this.selectHoliday && !this.checkLink(item.holiday_day)) return 'bg-primary text-white'
      else return 'bg-white text-dark'
    },

    //================= チェック処理
    // 引数の日付が空ではないか確認（引数が空ならば、紐づいていない）
    checkLink(day){
      if(day == null || day == ""){
        return false;
      }
      else{
        return true;
      }
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    }
  }
}
</script>
<style>
/* .TransferMatchModalContentVariant{
  min-width:1300px!important;
} */
.modal-fluid .modal-dialog{
  max-width: 95%;
}
.WorkM_InputGroup_ItemLabel_Transfer {
  font-size: 1.25rem;
  color: rgb(13, 91, 136);
  font-weight: 700;
  margin: 0;
}
.TransferMatchModalHeaderVariant {
  background-color:rgb(13, 91, 128);
}
.TransferMatchModal{
  width: 1000px;
}


.SubstitudeHolidayConditionArea{
  padding: 1rem;
  margin-bottom: 1rem;
  border-top: 1px solid rgb(82, 75, 75);
  border-bottom: 1px solid rgb(82, 75, 75);
}

.SubstituteWorkListtArea{
  border-bottom: 1px solid rgb(212, 212, 212);
}
.TransferSubstituteWorkListTable{
  min-height: 215px !important;
  max-height: 200px !important;
  border-bottom: 1px solid rgb(212, 212, 212);
  /* overflow-x: hidden; */
}
.TransferSubstituteWorkListTable table{
  border: none !important;
}
.TransferSubstituteWorkListTable th.table-header{
  font-weight: bold;
  background-color: rgb(13, 91, 136) !important;
  color:white !important;
  text-align: center !important;
}
.TransferSubstituteWorkListTable th.bg_transfer_holiday{
  background-color: rgb(0, 45, 100) !important;
  color:white !important;
}
.TransferSubstituteHolidayListTable{
  min-height: 215px !important;
  max-height: 200px !important;
  border-bottom: 1px solid rgb(212, 212, 212);
  /* overflow-x: hidden; */
}
.TransferSubstituteHolidayListTable table{
  border: none !important;
  border-bottom: 1px solid rgb(212, 212, 212);
}
.TransferSubstituteHolidayListTable th.table-header{
  font-weight: bold;
  background-color:rgb(0, 128, 128) !important;
  color:white !important;
  text-align: center !important;
}
.TransferSubstituteHolidayListTable th.bg_transfer_work{
  background-color: rgb(0, 73, 73) !important;
  color:white !important;
}
/* .TransferSubstituteHolidayListTable thead{
  position: sticky;
  top: 0;
} */
.col_transfer_radio{
  width:10%;
  min-width:45px;
  text-align: center !important;
}
.col_transfer_day{
  width:7%;
  min-width:90px;
  text-align: center !important;
}
.col_transfer_start{
  width:5%;
  min-width:50px;
  text-align: center !important;
}
.col_transfer_end{
  width:5%;
  min-width:50px;
  text-align: center !important;
}
.col_transfer_time{
  width:5%;
  min-width:95px;
  text-align: right !important;
}
.col_transfer_construction_code{
  width:5%;
  min-width: 65px;
  text-align: right !important;
}
.col_transfer_construction_name{
  width:25%;
  min-width:80px;
  text-align: left !important;
}
.transfer_icon_color_work{
  color:rgb(13, 91, 136);
  visibility: hidden;
}
.transfer_icon_color_holiday{
  color:rgb(0, 128, 128);
  visibility: hidden;
}
.transfer_icon_color_work2{
  color:rgb(13, 91, 136);
}
.transfer_icon_color_holiday2{
  color:rgb(0, 128, 128);
}

@media(min-width: 1870px){
  .dispTable{
    display: flex;
  }
  .TransferSubstituteWorkListTable{
    max-height: 300px !important;
    min-height: 510px !important;
    overflow-x:auto;
  }
  .TransferSubstituteHolidayListTable{
    max-height: 300px !important;
    min-height: 510px !important;
    overflow-x:auto;
  }
  .transfer_icon_color_work{
    visibility: visible;
  }
  .transfer_icon_color_holiday{
    visibility: visible;
  }
  .col_transfer_construction_name{
    max-width:110px;
  }
}
</style>